const NEW = "neu";
const COPY = "kopieren";
const SUB = "unterkategorie";

export { NEW, COPY, SUB };
